import React from 'react'
import FinOpsHero from './section/FinOpsHero.js'
import FinopsCard from './section/FinopsCard.js'
import Finopstools from './section/Finopstools.js'
import FionopsFaqs from './section/FionopsFaqs.js'
const FinOps = () => {
  return (
    <>
   <FinOpsHero/>
   <FinopsCard/>
   <Finopstools/>
   <FionopsFaqs/>
   </>
  )
}

export default FinOps